import React from "react"
import Flex from "../shared/flex"
import { Logo } from "../logo"

export const Header = () => (
  <Flex justify="between" align="center" css={{ padding: "1rem" }}>
    <Logo fontColor="#000" />
  </Flex>
)
